import PropTypes from "prop-types";
import classes from "./globalErrorBlock.scss";
import ReactHtmlParser from 'react-html-parser';
import {getLocalizedStrings} from './globalErrorLocalizedStrings';
import { setFocusToError } from "../../../MoveCenter/Common/moveCenterUtil";

const GlobalErrorBlock = props => {
  const strings = props.isClaims ? getLocalizedStrings('timeOutErrorStringsClaims') : getLocalizedStrings('timeOutErrorStrings');
  setFocusToError();
  if (props.isTimeoutError) {
    let checkGlobalErrorColor = props.errorColor;
    return(
      <div>
        <mark
          className={[
            "col-lg-12",
            "col-md-12",
            "col-sm-12",
            (checkGlobalErrorColor?classes.sceFieldHomeAlert:classes.sceFieldAlert)         
          ].join(" ")}
        >
          <span>
            <i className={'fas fa-exclamation-circle fa-lg'} />
          </span>
          <span className={checkGlobalErrorColor ? classes.sceFieldHomeAlertText : classes.sceAlertText}>
            {props.isClaims && ReactHtmlParser(strings.claimserrorMessage)}
            {strings.errorMessage1 && !props.isClaims ? 
            <span>
            {strings.errorMessage1 + ' '}
            <a href="https://ask.sce.com/">{strings.hyperlinkText} </a>
             {strings.errorMessage2}
            </span> : null}
          </span>
        </mark>
      </div>
    );
  }
  else if (props.errorMessage || props.errorLink) {
    let checkGlobalErrorColor = props.errorColor;
    return (
      <div>
        <mark
          className={[
            "col-lg-12",
            "col-md-12",
            "col-sm-12",
            (checkGlobalErrorColor?classes.sceFieldHomeAlert:classes.sceFieldAlert)         
          ].join(" ")}
        >
          <div className={props.centerContent ? 'container' : ''}>
            <span>
              <i className={'fas fa-exclamation-circle fa-lg'} />
            </span>
            <span className={checkGlobalErrorColor ? classes.sceFieldHomeAlertText : classes.sceAlertText}>
              {props.isErrorWithTag? ReactHtmlParser(props.errorMessage) :props.errorMessage ? <span className='errorMessage'>{props.errorMessage + ' '}{ReactHtmlParser(props.errorLink)}</span> : ReactHtmlParser(props.errorLink)}
            </span>
          </div>
        </mark>
      </div>
    );
  } else {
    return null;
  }
};

export default GlobalErrorBlock;

GlobalErrorBlock.defaultProps = {
  errorMessage: ""
};

GlobalErrorBlock.propTypes = {
  errorMessage: PropTypes.string
};
